import { useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const friendLinks = [
  { name: 'Meta', desc: 'Meta Platforms Inc.', url: 'https://meta.com', icon: 'ri-meta-line', category: '国际平台', color: '#4FC3F7', img: 'https://public.readdy.ai/ai/img_res/8807df459809b1bf5f9976a9abfd64e3.jpg' },
  { name: 'Decentraland', desc: '去中心化元宇宙', url: 'https://decentraland.org', icon: 'ri-global-line', category: '国际平台', color: '#FF6B35', img: 'https://readdy.ai/api/search-image?query=Decentraland%20metaverse%20virtual%20world%20blockchain%20orange%20neon%20logo%20brand&width=120&height=80&seq=fl-dcl-v2&orientation=landscape' },
  { name: 'The Sandbox', desc: '虚拟世界游戏', url: 'https://sandbox.game', icon: 'ri-gamepad-line', category: '国际平台', color: '#FFD700', img: 'https://readdy.ai/api/search-image?query=The%20Sandbox%20metaverse%20game%20virtual%20world%20yellow%20neon%20logo%20brand&width=120&height=80&seq=fl-sandbox-v2&orientation=landscape' },
  { name: 'Roblox', desc: '全球最大游戏元宇宙', url: 'https://roblox.com', icon: 'ri-game-line', category: '国际平台', color: '#FF6B9D', img: 'https://readdy.ai/api/search-image?query=Roblox%20gaming%20metaverse%20platform%20red%20logo%20brand%20colorful&width=120&height=80&seq=fl-roblox-v2&orientation=landscape' },
  { name: 'OpenSea', desc: '全球最大NFT平台', url: 'https://opensea.io', icon: 'ri-store-line', category: '国际平台', color: '#00FFCC', img: 'https://readdy.ai/api/search-image?query=OpenSea%20NFT%20marketplace%20blue%20teal%20logo%20brand%20digital%20art&width=120&height=80&seq=fl-opensea-v2&orientation=landscape' },
  { name: 'Horizon Worlds', desc: 'Meta元宇宙社交', url: 'https://horizon.meta.com', icon: 'ri-glasses-2-line', category: '国际平台', color: '#A855F7', img: 'https://readdy.ai/api/search-image?query=Meta%20Horizon%20Worlds%20VR%20social%20metaverse%20purple%20neon%20logo%20brand&width=120&height=80&seq=fl-horizon-v2&orientation=landscape' },
  { name: '腾讯XR', desc: '腾讯元宇宙业务', url: 'https://xr.tencent.com', icon: 'ri-qq-line', category: '国内平台', color: '#00FF88', img: 'https://readdy.ai/api/search-image?query=Tencent%20XR%20metaverse%20China%20tech%20company%20green%20neon%20logo%20brand&width=120&height=80&seq=fl-tencent-v2&orientation=landscape' },
  { name: 'Pico VR', desc: '字节跳动VR平台', url: 'https://picoxr.com', icon: 'ri-glasses-line', category: '国内平台', color: '#FF6B35', img: 'https://readdy.ai/api/search-image?query=Pico%20VR%20headset%20ByteDance%20virtual%20reality%20orange%20neon%20logo%20brand&width=120&height=80&seq=fl-pico-v2&orientation=landscape' },
  { name: '百度希壤', desc: '百度元宇宙平台', url: 'https://xrspace.baidu.com', icon: 'ri-baidu-line', category: '国内平台', color: '#4FC3F7', img: 'https://readdy.ai/api/search-image?query=Baidu%20Xirang%20metaverse%20China%20virtual%20world%20blue%20neon%20logo%20brand&width=120&height=80&seq=fl-baidu-v2&orientation=landscape' },
  { name: '网易瑶台', desc: '网易元宇宙会议', url: 'https://yaotai.163.com', icon: 'ri-building-line', category: '国内平台', color: '#FFD700', img: 'https://readdy.ai/api/search-image?query=NetEase%20Yaotai%20metaverse%20conference%20virtual%20meeting%20yellow%20neon%20logo%20brand&width=120&height=80&seq=fl-netease-v2&orientation=landscape' },
  { name: 'IEEE元宇宙', desc: 'IEEE技术标准', url: 'https://metaverse.ieee.org', icon: 'ri-book-open-line', category: '研究机构', color: '#00FFCC', img: 'https://readdy.ai/api/search-image?query=IEEE%20metaverse%20technology%20standards%20research%20institution%20teal%20neon%20logo%20brand&width=120&height=80&seq=fl-ieee-v2&orientation=landscape' },
  { name: 'XR Association', desc: '全球XR行业协会', url: 'https://xra.org', icon: 'ri-organization-chart', category: '研究机构', color: '#FF6B9D', img: 'https://readdy.ai/api/search-image?query=XR%20Association%20virtual%20reality%20augmented%20reality%20industry%20organization%20pink%20neon%20logo%20brand&width=120&height=80&seq=fl-xra-v2&orientation=landscape' },
];

const categories = ['全部', '国际平台', '国内平台', '研究机构'];

export default function FriendLinks() {
  const [activeCategory, setActiveCategory] = useState('全部');
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();

  const filtered = activeCategory === '全部' ? friendLinks : friendLinks.filter((l) => l.category === activeCategory);

  return (
    <section id="friend-links" className="relative py-20 overflow-hidden" style={{ background: '#040404' }}>
      {/* Doodle background */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 opacity-3" style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.06) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }} />
        <svg className="absolute top-0 left-0 w-full" height="5" viewBox="0 0 1440 5" preserveAspectRatio="none">
          <path d="M0,2.5 Q90,0 180,2.5 Q270,5 360,2.5 Q450,0 540,2.5 Q630,5 720,2.5 Q810,0 900,2.5 Q990,5 1080,2.5 Q1170,0 1260,2.5 Q1350,5 1440,2.5" stroke="#FFD700" strokeWidth="1.5" fill="none" strokeOpacity="0.25"/>
        </svg>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-10 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <h2 className="text-2xl font-black text-white mb-2" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            友情<span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFD700] to-[#FF6B35]"> 链接</span>
          </h2>
          <p className="text-white/30 text-sm" style={{ fontFamily: 'Caveat, cursive', fontSize: '0.95rem' }}>全球元宇宙生态伙伴与权威平台 · 共建数字文明</p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2 mb-8 justify-center">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className="px-5 py-2 text-xs font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{
                background: activeCategory === cat ? 'rgba(255,215,0,0.15)' : 'rgba(255,255,255,0.04)',
                border: `1.5px solid ${activeCategory === cat ? 'rgba(255,215,0,0.5)' : 'rgba(255,255,255,0.1)'}`,
                borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                color: activeCategory === cat ? '#FFD700' : 'rgba(255,255,255,0.35)',
                fontFamily: 'Caveat, cursive',
                fontSize: '0.9rem',
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {filtered.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group flex flex-col items-center gap-3 p-5 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              style={{
                background: 'rgba(255,255,255,0.03)',
                border: `1.5px solid rgba(255,255,255,0.08)`,
                borderRadius: '14px 10px 14px 10px / 10px 14px 10px 14px',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = `${link.color}50`;
                (e.currentTarget as HTMLElement).style.background = `${link.color}08`;
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.08)';
                (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.03)';
              }}
            >
              {/* Icon */}
              <div
                className="w-12 h-12 flex items-center justify-center transition-all duration-300"
                style={{
                  background: `${link.color}15`,
                  border: `1.5px solid ${link.color}30`,
                  borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                }}
              >
                <i className={`${link.icon} text-xl`} style={{ color: link.color }} />
              </div>
              {/* Name */}
              <p className="text-white/70 text-sm font-bold group-hover:text-white transition-colors text-center whitespace-nowrap" style={{ fontFamily: 'Caveat, cursive', fontSize: '0.95rem' }}>{link.name}</p>
              {/* Desc */}
              <p className="text-white/25 text-xs text-center line-clamp-1">{link.desc}</p>
              {/* Category badge */}
              <span
                className="text-xs px-2 py-0.5"
                style={{
                  color: link.color,
                  background: `${link.color}12`,
                  border: `1px solid ${link.color}25`,
                  borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                  fontFamily: 'Caveat, cursive',
                  fontSize: '0.75rem',
                }}
              >
                {link.category}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
